import { useLocation } from "react-router-dom";


const useIfRouteActive = (route, active, inactive) => {

    return useLocation().pathname === route ? active : inactive;

}

const isRouteActive = (location, route, active, inactive) => {
    return location === route ? active : inactive;
}


const capitalizeFirstLetter = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
}

let dmn;
if (process.env.NODE_ENV === "development") {
    dmn = "http://localhost:8000"
} else {
    dmn = window.location.host.includes('localhost') ? `http://${window.location.host}` : `https://${window.location.host}`;
}

const domain = dmn;

const productImageUrl = (src) => {
    if (!src) return '/no-product-card.webp';
    if (src.startsWith('/uploads/')) return `${domain}${src}`;
    return src;
};

export { useIfRouteActive, isRouteActive, capitalizeFirstLetter, domain, productImageUrl }